document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('#enq__form');

    // Function to validate individual fields
    const validateField = (inputId, errorClass, errorMessage) => {
        const input = document.querySelector(inputId);
        const errorElement = document.querySelector(errorClass);
        if (input.value.trim() === '') {
            errorElement.textContent = errorMessage;
            errorElement.style.display = 'block';
            return false;
        } else {
            errorElement.textContent = '';
            errorElement.style.display = 'none';
            return true;
        }
    };

    let captcha1Verified = false;

    window.onCaptcha1Success = function() {
      captcha1Verified = true;
      document.querySelector('.captcha__error').textContent = '';
    };

    const validateCaptcha = () => {
      if (!captcha1Verified) {
        const captchaError = document.querySelector('.captcha__error');
        captchaError.textContent = 'Please complete the Captcha.';
        captchaError.style.display = 'block';
        captchaError.style.color = '#FF000080';
        return false;
      }
      return true;
    };

    // Pincode input field validation - restrict to 6 digits and call fetchPincodeData when filled
    document.querySelector("#enq__pincode").addEventListener("input", function() {
      const pincode = this.value.replace(/\D/g, "").substring(0, 6); // Keep only the first 6 digits
      this.value = pincode; // Update field with the restricted value
      
      const errorMessage = document.querySelector('.pincode__error');
      
      if (pincode.length < 6) {
        errorMessage.textContent = "Pincode must be 6 digits";
        errorMessage.style.display = 'block';
        return false;
      } else {
        errorMessage.textContent = "";
        errorMessage.style.display = 'none';
        fetchPincodeData(pincode, "#enq__pincode__city", "#enq__pincode__state", ".pincode__error");
      }
    });

    // Trigger pincode data fetch on focus out (blur) event as well
    document.querySelector("#enq__pincode").addEventListener("focusout", function() {
      const pincode = this.value.replace(/\D/g, "").substring(0, 6); // Ensure pincode is 6 digits
      const errorMessage = document.querySelector('.pincode__error');
      
      if (pincode.length < 6) {
        errorMessage.textContent = "Pincode must be 6 digits";
        errorMessage.style.display = 'block';
        return false;
      } else {
        errorMessage.textContent = "";
        errorMessage.style.display = 'none';
        fetchPincodeData(pincode, "#enq__pincode__city", "#enq__pincode__state", ".pincode__error");
      }
    });

    // Attach blur event listeners
    document.querySelector('#enq__full__name').addEventListener('blur', () => {
        validateField('#enq__full__name', '.full__name__error', 'Please enter your Full Name');
    });

  /*  document.querySelector('#enq__phone').addEventListener('blur', () => {
        validateField('#enq__phone', '.phone__number__error', 'Please enter your Mobile Number');
    }); */

  /*  document.querySelector('#enq__phone').addEventListener('input', (e) => {
      let phoneValue = e.target.value;

      // Limit the input to 10 digits
      if (phoneValue.length > 10) {
          e.target.value = phoneValue.slice(0, 10);
      }

      // Show error if phone number is less than 10 digits
      if (phoneValue.length < 10) {
          document.querySelector('.phone__number__error').textContent = 'Please enter a valid 10-digit Mobile Number';
          // isValid = false;  // Mark as invalid
      } else {
          document.querySelector('.phone__number__error').textContent = ''; // Clear error message when valid
          // isValid = true;  // Mark as valid
      }
  }) */
  document.querySelector('#enq__phone').addEventListener('blur', () => {
        validateField('#enq__phone', '.phone__number__error', 'Please enter your Mobile Number');
    });

    document.querySelector('#enq__phone').addEventListener('input', (e) => {
      // Remove any non-digit characters and leading zeros
      let phoneValue = e.target.value.replace(/\D/g, '').replace(/^0+/, '');

      // Limit the input to 10 digits
      if (phoneValue.length > 10) {
          phoneValue = phoneValue.slice(0, 10);
      }

      // Update input value
      e.target.value = phoneValue;

      // Show error if phone number is less than 10 digits
      if (phoneValue.length < 10) {
          document.querySelector('.phone__number__error').textContent = 'Please enter a valid 10-digit Mobile Number';
          // isValid = false;  // Mark as invalid
      } else {
          document.querySelector('.phone__number__error').textContent = ''; // Clear error message when valid
          // isValid = true;  // Mark as valid
      }
    })


    document.querySelector('#enq__email').addEventListener('blur', () => {
        validateField('#enq__email', '.email__error', 'Please enter your Email-ID');
    });

    document.querySelector('#enq__pincode').addEventListener('blur', () => {
        validateField('#enq__pincode', '.pincode__error', 'Please enter your Pincode');
    });

    // document.querySelector('#enq__product').addEventListener('blur', () => {
    //     validateField('#enq__product', '.product__error', 'Please select your Product');
    // });

    function showProductList(){
      const input = document.querySelector("#enq__product");
    const suggestionList = document.querySelector(".product__suggestion");

    // Show suggestions on focus
    input.addEventListener("focus", () => {
      suggestionList.classList.add("show");
    });

    // Hide suggestions on blur
    input.addEventListener("blur", () => {
      setTimeout(() => suggestionList.classList.remove("show"), 200);
    });

    // Add clicked suggestion to input value
    if (!window.location.href.includes("products")) {
        suggestionList.addEventListener("click", (e) => {
          if (e.target.tagName === "LI") {
            // Set the clicked text to the input field
            input.value = e.target.textContent;
            document.querySelector('.product__error').style.display = 'none';

            // Hide the suggestion list
            suggestionList.classList.remove("show");
          }
        });
      }
    }

    showProductList();

    // Form submit validation
    form.addEventListener('submit', (e) => {
        e.preventDefault(); // Prevent form submission
        let isValid = true;
        let errors = [];

        // Validate all fields and collect errors
        if (!validateField('#enq__full__name', '.full__name__error', 'Please enter your Full Name')) {
            isValid = false;
            errors.push(document.querySelector('.full__name__error'));
        }

        // Validate phone number (should be 10 digits)
        const phoneField = document.querySelector('#enq__phone');
        const phoneError = document.querySelector('.phone__number__error');
        const phoneValue = phoneField.value.trim();

        if (phoneValue.length !== 10 || !/^\d+$/.test(phoneValue)) {
            phoneError.textContent = 'Please enter a valid 10-digit Mobile Number';
            phoneError.style.display = 'block';
            isValid = false;
            errors.push(phoneError);
        } else {
            phoneError.textContent = '';
            phoneError.style.display = 'none';
        }

        // Validate pincode (must be 6 digits)
        const pincodeField = document.querySelector('#enq__pincode');
        const pincodeError = document.querySelector('.pincode__error');
        const pincodeValue = pincodeField.value.trim();

        if (pincodeValue.length !== 6 || !/^\d+$/.test(pincodeValue)) {
            pincodeError.textContent = 'Please enter a valid 6-digit Pincode';
            pincodeError.style.display = 'block';
            isValid = false;
            errors.push(pincodeError);
        } else {
            pincodeError.textContent = '';
            pincodeError.style.display = 'none';
        }

        if (!validateField('#enq__email', '.email__error', 'Please enter your Email-ID')) {
            isValid = false;
            errors.push(document.querySelector('.email__error'));
        }

        // Validate reCAPTCHA
        if (!validateCaptcha()) {
            isValid = false;
            errors.push(document.querySelector('.captcha__error'));
        }

        // If there are validation errors, scroll to the topmost error
        if (!isValid && errors.length > 0) {
            // Sort errors by their vertical position on the page
            errors.sort((a, b) => {
                return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
            });

            // Get the form container
            const formContainer = document.querySelector('.popup__form');
            
            // Scroll to the first error with offset
            formContainer.scrollTo({
                top: errors[0].offsetTop - 100,
                behavior: 'smooth'
            });
            return;
        }

        // If all fields are valid, submit the form
        if (isValid) {
            runApiCode();
        }
    });
  });

  async function runApiCode() {
    try {
      const enqButtonSelector = document.querySelector('.send__inquiry__button')
      enqButtonSelector.setAttribute('disabled', true);
      document.querySelector('.btn-ring').style.display = 'block';

      // Headers for the API request
      let headersList = {
        "Accept": "*/*",
      };

      // Retrieve form input values
      const enqFullName = document.querySelector('#enq__full__name')?.value || '';
      const enqPhoneNumber = document.querySelector('#enq__phone')?.value || '';
      const enqEmail = document.querySelector('#enq__email')?.value || '';
      const enqPincode = document.querySelector('#enq__pincode')?.value || '';
      const enqPincodeCity = document.querySelector('#enq__pincode__city')?.value || '';
      const enqPincodeState = document.querySelector('#enq__pincode__state')?.value || '';
      const enqProduct = document.querySelector('#enq__product')?.value || '';
      const enqApplication = document.querySelector('#enq__application')?.value || '';
      const enqCompany = document.querySelector('#enq__company')?.value || '';
      const enqDetails = document.querySelector('#enq__details')?.value || '';
      const enqHref = window.location.href;
      const pageTitle = document.title; 
      // FormData object with appended data
      let formdata = new FormData();
      formdata.append("locale", "en");
      formdata.append("time_zone", "Asia/Calcutta");
      formdata.append("name-1", enqFullName);
      formdata.append("phone-1", enqPhoneNumber);
      formdata.append("email-1", enqEmail);
      formdata.append("number-1", enqPincode);
      formdata.append("text-1", enqPincodeCity);
      formdata.append("text-2", enqPincodeState);
      formdata.append("text-3", enqProduct);
      formdata.append("text-4", enqApplication);
      formdata.append("text-5", enqCompany);
      formdata.append("text-6", enqDetails);
      formdata.append("customer[id]" , " ");
      formdata.append("customer[email]" , " ");
      formdata.append("customer[name]" , " ");
      formdata.append("page[title]" , pageTitle );
      formdata.append("page[href]", enqHref);
      formdata.append(
        "_keyLabel",
        JSON.stringify({
          "name-1": "Full Name",
          "phone-1": "Phone Number",
          "email-1": "Email",
          "number-1": "Pincode",
          "text-1": "City",
          "text-2": "State",
          "text-3": "Product",
          "text-4": "Application",
          "text-5": "Company",
          "text-6": "Details",
        })
      );

      // API request options
      let reqOptions = {
        url: "https://app.powerfulform.com/api/front/form/69003/send",
        method: "POST",
        headers: headersList,
        data: formdata,
      };

      // Send API request and handle the response
      let response = await axios.request(reqOptions);
      // console.log("Response Data:", response.data);
      if (response.data.success === "true") {
          const headingSelector = document.querySelector('.popup__heading');
          const formSelector = document.querySelector('.popup__form');
          const thankyouSelector = document.querySelector('.thankyou__conatienr');
          const lottieSelector = document.querySelector('.lottie__append');

          headingSelector.style.display = 'none';
          formSelector.style.display = 'none';
          thankyouSelector.style.display = 'flex';

          lottieSelector.innerHTML = `
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /><path class="" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /></svg>
      `;
      enqButtonSelector.removeAttribute('disabled');
      document.querySelector('.btn-ring').style.display = 'none';
      const formInputs = formSelector.querySelectorAll('input, textarea, select');
      formInputs.forEach(input => {
          if (input.type === 'checkbox' || input.type === 'radio') {
              input.checked = false; // Uncheck checkboxes and radio buttons
          } else {
              input.value = ''; // Clear text, email, password, and other input fields
          }
      });
      }
    } catch (error) {
      enqButtonSelector.removeAttribute('disabled');
      console.error("API Request Failed:", error);
    }
  }

  const inputValue = document.querySelector('.arrow__down__icon');
  let isOpen = false;
  inputValue.addEventListener('click', () => {
    isOpen = !isOpen;
     const suggestionList = document.querySelector(".product__suggestion");
    if (isOpen) {
      // Show suggestions on focus
    
      suggestionList.classList.add("show");
    } else {
      console.log('clicked close'); 
      setTimeout(() => suggestionList.classList.remove("show"), 200);
    }
  });
